export * from './Pacman';
export { default } from './Pacman';
